export enum ImpersonateCookie {
  Email = 'IMPERSONATION_EMAIL',
  UserId = 'IMPERSONATION_USER_ID',
  IdToken = 'IMPERSONATION_ID_TOKEN',
  AccessToken = 'IMPERSONATION_ACCESS_TOKEN',
  RefreshToken = 'IMPERSONATION_REFRESH_TOKEN',
  ExpiresIn = 'IMPERSONATION_EXPIRES_IN',
}
